import { DocumentType } from '@sib/api';
import { DEFAULT_TO_VALUE, NUMBER_RANGE_UPPER_MAX } from '@sib/ui';
import { DEFAULT_CURRENCY } from '@sib/utils';

export const DEFAULT_MIN_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZES = [5, 10, 20, 50, 100];
export const EXCLUDED_DOCUMENT_TYPE = DocumentType.Invoice;

export const DEFAULT_MIN_COLUMN_SIZE = 200;
export const DEFAULT_SELECT_COLUMN_SIZE = 50;

export const DATA_TABLE_GROUP_HEADER_HEIGHT = '2.25rem';
export const DATA_TABLE_GROUP_HEADER_HEIGHT_VAR =
  '--data-table-group-header-height';

export const pageSizeOptions = PAGE_SIZES.map(size => ({
  label: size,
  value: String(size),
}));

/** A column filter for numbers of zero or more, such as counts and quantities. */
export const NUMBER_RANGE_TABLE_FILTER = {
  FilterProps: {
    type: 'number_range' as const,
    ranges: {
      min: 0,
      defaultTo: DEFAULT_TO_VALUE,
      max: NUMBER_RANGE_UPPER_MAX,
    },
  },
};

/** Like `NUMBER_RANGE_TABLE_FILTER`, for amounts in the default currency. */
export const CURRENCY_RANGE_TABLE_FILTER = {
  FilterProps: {
    ...NUMBER_RANGE_TABLE_FILTER.FilterProps,
    ranges: {
      ...NUMBER_RANGE_TABLE_FILTER.FilterProps.ranges,
      unit: DEFAULT_CURRENCY.symbol,
    },
  },
};
